import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const openLeadForm = () => {
    window.dispatchEvent(new CustomEvent('openLeadForm'));
  };

  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Firm Info */}
          <div className="col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_d9eb1bfb-a60c-4d75-9f49-96d39f58fd2c/artifacts/ex3cr57e_footer-logo.png" 
              alt="Tiller Kingsley Bale Associates" 
              style={{ height: '4rem' }}
              className="w-auto mb-4"
            />
            <p className="text-sm text-slate-400 leading-relaxed">
              Trusted legal counsel delivering exceptional results for businesses and individuals. 
              We combine expertise with dedication to protect your interests and achieve your goals.
            </p>
          </div>

          {/* Business & Corporate Law */}
          <div>
            <h3 className="text-white font-semibold mb-4">Business & Corporate Law</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services/corporate-business-contracts" className="hover:text-amber-600 transition-colors">Corporate Contracts</Link></li>
              <li><Link to="/services/corporate-business-formation" className="hover:text-amber-600 transition-colors">Business Formation</Link></li>
              <li><Link to="/services/business-transactions" className="hover:text-amber-600 transition-colors">Business Transactions</Link></li>
              <li><Link to="/services/mergers-acquisitions" className="hover:text-amber-600 transition-colors">Mergers & Acquisitions</Link></li>
              <li><Link to="/services/non-profit-law" className="hover:text-amber-600 transition-colors">Non-Profit Law</Link></li>
              <li><Link to="/services/government-contracting" className="hover:text-amber-600 transition-colors">Government Contracting</Link></li>
            </ul>
          </div>

          {/* Other Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Other Services</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services/business-disputes" className="hover:text-amber-600 transition-colors">Business Disputes</Link></li>
              <li><Link to="/services/anti-corruption-compliance" className="hover:text-amber-600 transition-colors">Anti-Corruption Compliance</Link></li>
              <li><Link to="/services/immigration" className="hover:text-amber-600 transition-colors">Immigration</Link></li>
              <li><Link to="/services/trademark-registration" className="hover:text-amber-600 transition-colors">Trademark Registration</Link></li>
              <li><Link to="/services/copyright-registration" className="hover:text-amber-600 transition-colors">Copyright Registration</Link></li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h3 className="text-white font-semibold mb-4">Information</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:info@tillerkingsleybaleassociates.com" className="hover:text-amber-600 transition-colors flex items-start gap-2">
                  <Mail className="h-4 w-4 mt-0.5 flex-shrink-0" />
                  <span>info@tillerkingsleybaleassociates.com</span>
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 mt-0.5 flex-shrink-0 text-amber-600" />
                <span>+1 (844) 386-5026</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0 text-amber-600" />
                <span>44 Tehama St<br />San Francisco, CA 94105</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-6 bg-amber-700 text-white hover:bg-amber-800 px-6 py-2.5 text-sm font-medium transition-colors shadow-lg inline-block"
              data-testid="footer-contact-button"
            >
              Contact Us
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
            <p>&copy; 2026 Tiller Kingsley Bale Associates. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="hover:text-amber-600 transition-colors">Privacy Policy</Link>
              <Link to="/terms-conditions" className="hover:text-amber-600 transition-colors">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
